// extracted by mini-css-extract-plugin
export default {"containprod":"zC","containprod2":"AC","title":"BC","servings":"CC","recommendation":"EC","image":"FC","flavorswrap":"GC","flavorsgroupwrap":"HC","moredetailsWrap":"IC","infoWrap":"JC","price":"KC","regularPrice":"LC","netPrice":"MC","addtocartcontainer":"NC","error":"OC"};
    if(module.hot) {
      // 1715091679187
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  